<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">{{ type }}</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Filter -->
    <div class="row align-items-center">
      <template v-if="type != 'My FWA Record'">
        <div class="col-md-2 w-170">Company</div>
        <div class="col-md-4 p-0 w-330">
          <select class="custom-select" v-model="company">
            <option
              v-for="(item, i) in companies"
              :key="i"
              :value="item.CompanyName"
            >
              {{ item.CompanyName }}
            </option>
          </select>
        </div>
        <div class="col-md-2 ml-md-5 w-175">Employee Name/ID</div>
        <div class="col-md-4 pl-md-0">
          <Select2 v-model="userId" :options="employees" />
        </div>
      </template>
      <template v-else>
        <div class="col-md-2 w-170">Employee Name/ID</div>
        <div class="col-md-4 pl-0">
          {{ tokenObj.Name }} ({{ tokenObj.EmployeeID }})
        </div>
      </template>
    </div>

    <div class="row align-items-center mt-2" v-if="type == 'My FWA Record'">
      <div class="col-md-2 w-170">1st Level Approver</div>
      <div class="col-md-4 p-0 w-330">
        <template v-if="type == 'My FWA Record'">
          {{
            firstLevelApproverName && firstLevelApproverEmployeeID
              ? `${firstLevelApproverName} (${firstLevelApproverEmployeeID})`
              : ""
          }}
        </template>
        <template
          v-else-if="
            type == 'My Staff FWA Record' && isManager && !isNextManager
          "
        >
          {{ tokenObj.Name }} ({{ tokenObj.EmployeeID }})
        </template>
        <template v-else>
          <Select2
            v-model="firstLevelApproverUserId"
            :options="firstLevelApprovers"
          />
        </template>
      </div>
      <div class="col-md-2 ml-md-5 w-175">2nd Level Approver</div>
      <div class="col-md-4 pl-md-0">
        <template v-if="type == 'My FWA Record'">
          {{
            secondLevelApproverName && secondLevelApproverEmployeeID
              ? `${secondLevelApproverName} (${secondLevelApproverEmployeeID})`
              : ""
          }}
        </template>
        <template v-else-if="type == 'My Staff FWA Record' && isNextManager">
          {{ tokenObj.Name }} ({{ tokenObj.EmployeeID }})
        </template>
        <template v-else>
          <Select2
            v-model="secondLevelApproverUserId"
            :options="secondLevelApprovers"
          />
        </template>
      </div>
    </div>

    <div class="row align-items-center mt-2">
      <div class="col-md-2 w-170">Year</div>
      <div class="col-md-2 p-0 fit-content">
        <select class="custom-select" v-model="year">
          <option value>All</option>
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>
      <div class="col-md-2 ml-md-4 fit-content">Date From</div>
      <div class="col-md-2 p-0 fit-content">
        <input type="date" class="form-control" v-model="dateFrom" />
      </div>
      <div class="col-md-2 ml-17 fit-content">Date To</div>
      <div class="col-md-2 p-0 fit-content">
        <input type="date" class="form-control" v-model="dateTo" />
      </div>
    </div>

    <div class="row align-items-center mt-2">
      <div class="col-md-2 w-170">Status</div>
      <div class="col-md-4 p-0 w-330">
        <select class="custom-select" v-model="status">
          <option value>All</option>
          <option value="Pending Approval">Pending Approval</option>
          <option value="Withdrawn">Withdrawn</option>
          <option value="Approved">Approved</option>
          <option value="Rejected">Rejected</option>
          <option value="Pending Cancellation">Pending Cancellation</option>
          <option value="Cancelled">Cancelled</option>
        </select>
      </div>
      <div class="col-md-2 ml-md-5">
        <button type="button" class="btn btn-primary" @click="getFwaRecords">
          Search
        </button>
      </div>
    </div>
    <!-- /Filter -->

    <!-- Pagination -->
    <div class="row mt-4">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center" v-if="type == 'My FWA Record'">
                  Cancel / Withdraw
                </th>
                <th class="text-center">View / Audit Log</th>
                <th v-if="type != 'My FWA Record'">Employee ID</th>
                <th v-if="type != 'My FWA Record'">Employee Name</th>
                <th>1st Level Approver</th>
                <th>2nd Level Approver</th>
                <th>FWA Type</th>
                <th>FWA Start Date</th>
                <th>FWA End Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in records" :key="item.Id">
                <td class="text-center" v-if="type == 'My FWA Record'">
                  <button
                    v-if="
                      item.Status == 'Approved' &&
                      !item.FirstLevelCancelationApprovalAction &&
                      !item.SecondLevelCancelationApprovalAction &&
                      !item.WithdrawBy
                    "
                    type="button"
                    class="btn btn-sm btn-danger"
                    @click="cancel(item.Id)"
                  >
                    <i class="fa fa-ban mr-1"></i>Cancel
                  </button>
                  <button
                    v-if="item.Status == 'Pending Approval'"
                    type="button"
                    class="btn btn-sm btn-secondary"
                    @click="withdraw(item.Id)"
                  >
                    <i class="fa fa-reply mr-1"></i>Withdraw
                  </button>
                  <button
                    v-if="item.Status == 'Pending Cancellation'"
                    type="button"
                    class="btn btn-sm btn-secondary"
                    @click="withdrawCancellation(item.Id)"
                  >
                    <i class="fa fa-reply mr-1"></i>Withdraw
                  </button>
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary"
                    @click="view(item.Id)"
                  >
                    <i class="fa fa-file-text-o mr-1"></i>View
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary"
                    @click="viewAuditLog(item.Id)"
                  >
                    <i class="fa fa-history mr-1"></i>Audit Log
                  </button>
                </td>
                <td v-if="type != 'My FWA Record'">{{ item.EmployeeID }}</td>
                <td v-if="type != 'My FWA Record'">{{ item.EmployeeName }}</td>
                <td>
                  {{
                    item.FirstLevelApproverEmployeeName &&
                    item.FirstLevelApproverEmployeeID
                      ? `${item.FirstLevelApproverEmployeeName} (${item.FirstLevelApproverEmployeeID})`
                      : ""
                  }}
                </td>
                <td>
                  {{
                    item.SecondLevelApproverEmployeeName &&
                    item.SecondLevelApproverEmployeeID
                      ? `${item.SecondLevelApproverEmployeeName} (${item.SecondLevelApproverEmployeeID})`
                      : ""
                  }}
                </td>
                <td>{{ item.Type }}</td>
                <td>{{ item.StartDateDisplay }}</td>
                <td>{{ item.EndDateDisplay }}</td>
                <td>{{ item.Status }}</td>
              </tr>
              <tr v-if="records && !records.length">
                <td colspan="9" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="records && records.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          records.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Audit Log Modal -->
    <div class="modal custom-modal fade" id="auditLogModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div
            class="modal-header pt-4"
            style="border-bottom: 1px solid lightgrey"
          >
            <h5 class="modal-title">Audit Log</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <table
              class="table table-bordered custom-table log-table my-0"
              style="width: 100%"
            >
              <thead class="thead-light">
                <tr>
                  <th style="width: 5%">Level</th>
                  <th>Name</th>
                  <th style="width: 27%">Date</th>
                  <th style="width: 20%">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in auditLogs" :key="item.Id">
                  <td class="text-center">{{ item.Level }}</td>
                  <td>{{ item.Name }}</td>
                  <td v-html="item.DateDisplay"></td>
                  <td>{{ item.Action }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- /Audit Log Modal -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import $ from "jquery";
export default {
  props: ["type"],
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      defaultCompany: config.DEFAULT_COMPANY,
      auditLogs: [],
      records: [],
      company: "",
      companies: [],
      userId: "00000000-0000-0000-0000-000000000000",
      managerEmployees: [],
      nextManagerEmployees: [],
      allEmployees: [],
      year: "",
      dateFrom: "",
      dateTo: "",
      firstLevelApprovers: [],
      firstLevelApproverUserId: "00000000-0000-0000-0000-000000000000",
      firstLevelApproverEmployeeID: "",
      firstLevelApproverName: "",
      secondLevelApprovers: [],
      secondLevelApproverUserId: "00000000-0000-0000-0000-000000000000",
      secondLevelApproverEmployeeID: "",
      secondLevelApproverName: "",
      status: "",
      fwaYears: [],
      //paging
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 100,
        Sizes: [5, 10, 20, 100],
      },
      totalRecords: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    isManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsManager ? data.IsManager : false;
    },
    isNextManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsNextManager ? data.IsNextManager : false;
    },
    years() {
      let date = new Date();
      let minYear = date.getFullYear() - 2;
      minYear =
        this.fwaYears.length > 0 && this.fwaYears[0] < minYear
          ? this.fwaYears[0]
          : minYear;
      let maxYear = date.getFullYear() + 1;
      maxYear =
        this.fwaYears.length > 0 &&
        this.fwaYears[this.fwaYears.length - 1] > maxYear
          ? this.fwaYears[this.fwaYears.length - 1]
          : maxYear;
      let years = [];
      for (let year = maxYear; year > minYear; year--) {
        years.push(year);
      }
      return years;
    },
    employees() {
      let employees = [];
      if (this.role == "admin") employees = this.allEmployees;
      else {
        let combinedEmployees = this.managerEmployees.concat(
          this.nextManagerEmployees
        );
        //remove duplicate
        employees = combinedEmployees.filter(
          (obj, index, self) => index === self.findIndex((o) => o.id === obj.id)
        );
      }
      employees.sort((a, b) => a.text.localeCompare(b.text));
      employees.unshift({
        department: "",
        id: "00000000-0000-0000-0000-000000000000",
        text: "All",
        Company: "",
      });
      return employees;
    },
  },
  watch: {
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getFwaRecords();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
    company(val) {
      //get employee list
      if (this.role == "admin") {
        this.getEmployees();
      } else {
        if (this.isManager) this.getManagerEmployees();
        if (this.isNextManager) this.getNextManagerEmployees();
      }
      //get manager list
      if (this.type != "My FWA Record") this.getAllFwaApprovers();
    },
  },
  methods: {
    //filter
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
            if (
              this.companies.find(
                (c) => c.CompanyName == this.defaultCompany
              ) == null
            ) {
              this.companies.push({ CompanyName: this.defaultCompany });
            }
            this.company = this.defaultCompany;
            this.getFwaRecords();
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getManagerEmployees() {
      let param = {
        Token: this.token,
        ManagerID: this.tokenObj.EmployeeID,
        Company: this.company,
      };
      this.$store.state.isLoading = true;
      API.getManagerEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.managerEmployees = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getNextManagerEmployees() {
      let param = {
        Token: this.token,
        ManagerID: this.tokenObj.EmployeeID,
        Company: this.company,
      };
      this.$store.state.isLoading = true;
      API.getNextManagerEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.nextManagerEmployees = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getEmployees() {
      let param = { Token: this.token, Company: this.company };
      this.$store.state.isLoading = true;
      API.getEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.allEmployees = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getFwaApproverInfo() {
      let param = {
        Token: this.token,
        Id: this.tokenObj.Id,
      };
      this.$store.state.isLoading = true;
      API.getFwaApproverInfo(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.firstLevelApproverEmployeeID =
              response.data.firstLevelApproverEmployeeID;
            this.firstLevelApproverName = response.data.firstLevelApproverName;
            this.secondLevelApproverEmployeeID =
              response.data.secondLevelApproverEmployeeID;
            this.secondLevelApproverName =
              response.data.secondLevelApproverName;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getAllFwaApprovers() {
      let param = {
        Token: this.token,
        Company: this.company,
      };
      this.$store.state.isLoading = true;
      API.getAllFwaApprovers(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.firstLevelApprovers = response.data.firstLevelApprovers;
            this.firstLevelApprovers.unshift({
              id: "00000000-0000-0000-0000-000000000000",
              text: "All",
            });
            this.secondLevelApprovers = response.data.secondLevelApprovers;
            this.secondLevelApprovers.unshift({
              id: "00000000-0000-0000-0000-000000000000",
              text: "All",
            });
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //main function
    getFwaRecords() {
      let param = {
        Token: this.token,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        Company: this.company,
        UserId: this.type == "My FWA Record" ? this.tokenObj.Id : this.userId,
        Year: this.year,
        DateFrom: this.dateFrom,
        DateTo: this.dateTo,
        FirstLevelApproverUserId:
          this.type == "My Staff FWA Record" &&
          this.isManager &&
          !this.isNextManager
            ? this.tokenObj.Id
            : this.firstLevelApproverUserId,
        SecondLevelApproverUserId:
          this.type == "My Staff FWA Record" && this.isNextManager
            ? this.tokenObj.Id
            : this.secondLevelApproverUserId,
        Status: this.status,
      };
      this.$store.state.isLoading = true;
      API.getFwaRecords(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            this.fwaYears = response.data.fwaYears;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    view(fwaId) {
      this.$store.state.fwaSourcePage = this.type;
      this.$router.push({ name: "fwaView", params: { id: fwaId } });
    },
    cancel(fwaId) {
      let param = {
        Token: this.token,
        Id: fwaId,
        Fwa: { Action: "Cancel" },
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to cancel the application?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.submitFwa(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.getFwaRecords();
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    withdraw(fwaId) {
      let param = {
        Token: this.token,
        Id: fwaId,
        Fwa: { Action: "Withdraw" },
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to withdraw the application?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.submitFwa(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.getFwaRecords();
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    withdrawCancellation(fwaId) {
      let param = {
        Token: this.token,
        Id: fwaId,
        Fwa: { Action: "Withdraw Cancellation" },
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to withdraw the cancellation request?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.submitFwa(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.getFwaRecords();
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    viewAuditLog(fwaId) {
      this.auditLogs = [];
      let rec = this.records.find((c) => c.Id == fwaId);
      if (rec) this.auditLogs = rec.AuditLogs;
      $("#auditLogModal").modal("show");
    },
    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getFwaRecords();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getFwaRecords();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getFwaRecords();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getFwaRecords();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getFwaRecords();
    },
  },
  created() {
    if (this.type == "My FWA Record") {
      this.getFwaApproverInfo();
      this.getFwaRecords();
    }
    if (this.type != "My FWA Record") this.getCompanies();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}
.w-170 {
  max-width: 170px;
}
.w-175 {
  max-width: 175px;
}
.w-330 {
  max-width: 330px;
}
.ml-17 {
  margin-left: 17px;
}

.table.log-table > tbody > tr > td,
.table.log-table > thead > tr > th {
  padding: 5px 10px !important;
}
.table.log-table > tbody > tr > td {
  font-size: 14px !important;
  line-height: 17px !important;
}
.modal-lg {
  max-width: 600px !important;
}
@media only screen and (max-width: 1400px) {
  .w-170,
  .w-175 {
    max-width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Fwa/FwaRecord.vue